import { LiveTvOutlined } from "@mui/icons-material";
import { update } from "lodash";

// Function to get the correct server URL based on hostname
function getServerUrl() {
  // First check if we have an environment variable (but ignore if it's an empty string)
  if (process.env.SK_SKCORE_SERVERURL && process.env.SK_SKCORE_SERVERURL.trim() !== '') {
    return process.env.SK_SKCORE_SERVERURL;
  }
  
  // Runtime fallback based on hostname
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    const devHosts = [
      'dev.siki.io',
      'memehouse.dev.siki.io',
    ];

    const stagingHosts = [
      'staging.siki.io',
      "memehouse.staging.siki.io",
    ];

    if (devHosts.includes(hostname)) {
      // Use dev-core.siki.io domain for dev environment
      return 'https://dev-core.siki.io';
    } else if (stagingHosts.includes(hostname)) {
      // Use staging-core.siki.io domain for staging environment
      return 'https://staging-core.siki.io';
    } else if (
      hostname === 'siki.io' ||
      hostname === 'www.siki.io' ||
      hostname === 'memehouse.siki.io' ||
      (hostname.endsWith('.siki.io') && !hostname.includes('staging'))
    ) {
      // Production siki.io domains (including themed sites like memehouse.siki.io)
      return 'https://core.siki.io';
    }
  }
  
  // Check NODE_ENV for staging
  if (process.env.NODE_ENV === 'staging') {
    return 'https://staging-core.siki.io';
  }
  
  // Default fallback - Use local backend
  return 'http://localhost:4041';
}

export const SERVER_URL = getServerUrl();

export const GOOGLE_CLIENT_ID = (process.env.SK_GOOGLE_AUDWEB && process.env.SK_GOOGLE_AUDWEB.trim() !== '') ? process.env.SK_GOOGLE_AUDWEB : '1005874412531-nq97k0smjkvdcuf99gog38c5m54h4mvl.apps.googleusercontent.com';
export const S3_BUCKET = process.env.SK_AWS_BUCKETNAME || '';
export const APPLE_CLIENT_ID = process.env.SK_APPLE_CLIENTID || '';
export const APPLE_REDIRECT_URI = process.env.SK_APPLE_REDIRECT_URI || '';
export const OBS_SERVER_URL = process.env.SK_OBS_SERVERURL || '';
export const OBS_CHANNEL_URL = process.env.SK_OBS_CHANNELURL || '';

export const API = {
// Admin Feature/Unfeature
  ADMIN_FEATURE_ARTIST: `${SERVER_URL}/admin/feature/artist`,
  ADMIN_UNFEATURE_ARTIST: `${SERVER_URL}/admin/unfeature/artist`,
  ADMIN_FEATURE_MUSIC: `${SERVER_URL}/admin/feature/music`,
  ADMIN_UNFEATURE_MUSIC: `${SERVER_URL}/admin/unfeature/music`,
  ADMIN_FEATURE_VIDEO: `${SERVER_URL}/admin/feature/video`,
  ADMIN_UNFEATURE_VIDEO: `${SERVER_URL}/admin/unfeature/video`,
  
  // Video endpoints
  GET_VIDEO: `${SERVER_URL}/video`,
  GET_RELATED_VIDEOS: `${SERVER_URL}/videos/related`,
  TRACK_VIDEO_VIEW: `${SERVER_URL}/video`,
  LIKE_VIDEO: `${SERVER_URL}/video`,
  VIDEO_COMMENTS: `${SERVER_URL}/video`,
  ADMIN_FEATURE_PLAYLIST: `${SERVER_URL}/admin/feature/playlist`,
  ADMIN_UNFEATURE_PLAYLIST: `${SERVER_URL}/admin/unfeature/playlist`,
  ADMIN_USER_STREAMING_BALANCE: `${SERVER_URL}/admin/user/streaming-balance`, // GET: check balance, POST: add to balance
  ADMIN_USER_STREAM_TRANSACTIONS: `${SERVER_URL}/admin/user/stream-transactions`,
  ADMIN_USER_STREAM_TRANSACTIONS_SUMMARY: `${SERVER_URL}/admin/user/stream-transactions/summary`,
  ADMIN_LEDGER_TRANSACTIONS: `${SERVER_URL}/admin/ledger/transactions`,
  ADMIN_LEDGER_SUMMARY: `${SERVER_URL}/admin/ledger/summary`,
  ADMIN_GROWTH_METRICS: `${SERVER_URL}/admin/growth/metrics`,
  // Business agents (owner-only): overview, switches, runs, approval queue, contacts
  ADMIN_AGENTS: `${SERVER_URL}/admin/agents`,
  ADMIN_AGENTS_SETTINGS: `${SERVER_URL}/admin/agents/settings`,
  ADMIN_AGENT_RUNS: `${SERVER_URL}/admin/agents/runs`,
  ADMIN_AGENT_ITEMS: `${SERVER_URL}/admin/agents/items`,
  ADMIN_AGENT_CONTACTS: `${SERVER_URL}/admin/agents/contacts`,


  // Admin Error Logs
  ADMIN_ERROR_LOGS: `${SERVER_URL}/admin/error-logs`,
  ADMIN_ERROR_LOG_STATS: `${SERVER_URL}/admin/error-logs/stats`,

  // Admin Other Actions
  ADMIN_BALANCE: `${SERVER_URL}/admin/balance`,
  ADMIN_VERIFY_ARTIST: `${SERVER_URL}/admin/verify/artist`,
  ADMIN_WHITELIST: `${SERVER_URL}/admin/whitelist`,
  ADMIN_WHITELIST_USER: `${SERVER_URL}/admin/whitelist/user`,
  ADMIN_SEARCH_ARTIST: `${SERVER_URL}/admin/search/artist`,
  ADMIN_GET_ALL_USERS: `${SERVER_URL}/admin/user/list`,
  ADMIN_ASSOCIATE_WALLET: `${SERVER_URL}/admin/user/associate-wallet`,
  ADMIN_UPDATE_STATUS: `${SERVER_URL}/admin/update/status`,
  ADMIN_GET_ALL_REQUESTS: `${SERVER_URL}/admin/token/request`,
  ADMIN_FREEZE_USERS: `${SERVER_URL}/admin/freeze/users`,
  ADMIN_USER: `${SERVER_URL}/admin/user`,
  ADMIN_USER_CONTENT: `${SERVER_URL}/admin/user`, // Will append /:userId/content
  ADMIN_FREEZE_SONGS: `${SERVER_URL}/admin/freeze/songs`,
  ADMIN_GET_ALL_PLAYLISTS: `${SERVER_URL}/admin/all/playlists`,
  ADMIN_GET_FLAGGED_ASSETS: `${SERVER_URL}/admin/get/flag/asset`,
  ADMIN_UNFREEZE_ASSETS: `${SERVER_URL}/admin/unfreeze/assets`,
  ADMIN_GET_FLAGS: `${SERVER_URL}/admin/flags`,
  ADMIN_REVIEW_FLAG: `${SERVER_URL}/admin/flag/review`,
  ADMIN_RESTORE_CONTENT: `${SERVER_URL}/admin/content/restore`,
  ADMIN_UPLOAD_BANNER: `${SERVER_URL}/admin/upload/banner`,
  ADMIN_DISABLE_SERVER: `${SERVER_URL}/admin/disable/server`,
  ADMIN_DELETE_BANNERS: `${SERVER_URL}/admin/delete/banners`,
  ADMIN_TOGGLE_BANNER_VISIBILITY: `${SERVER_URL}/admin/toggle/banner/visibility`,

  // PowerPlays
  POWERPLAYS: `${SERVER_URL}/public/powerplays`,
  ADMIN_POWERPLAYS: `${SERVER_URL}/admin/powerplays`,
  POWERPLAYS_UPLOAD: `${SERVER_URL}/admin/powerplays/upload`,
  ADMIN_REFRESH_SECRETS: `${SERVER_URL}/admin/refresh-secrets`,
  PROFIT_BREAKDOWN: `${SERVER_URL}/profit-breakdown`,
  ADMIN_SEED_ES: `${SERVER_URL}/admin/seed-es`,
  ADMIN_PROCESS_ROYALTIES: `${SERVER_URL}/admin/royalties`,
  ADMIN_RELEASE_LATEST_MUSIC: `${SERVER_URL}/admin/release-latest-music`,
  ADMIN_LOG_LEVEL: `${SERVER_URL}/admin/log-level`,
  ADMIN_GET_MLC: `${SERVER_URL}/admin/mlc`,
  ADMIN_END_LIVESTREAM: `${SERVER_URL}/admin/end-livestream`,
  ADMIN_MANAGE_ROLE: `${SERVER_URL}/admin/manage-role`,
  ADMIN_GET_ADMIN_USERS: `${SERVER_URL}/admin/admin-users`,
  ADMIN_MANAGE_MODERATOR_ROLE: `${SERVER_URL}/admin/manage-moderator-role`,
  ADMIN_GET_MODERATOR_USERS: `${SERVER_URL}/admin/moderator-users`,
  ADMIN_MANAGED_USERS: `${SERVER_URL}/admin/managed-users`,
  ADMIN_UNMANAGED_USERS: `${SERVER_URL}/admin/unmanaged-users`,
  ADMIN_CLAIM_USER: `${SERVER_URL}/admin/claim-user`,
  ADMIN_RELEASE_USER: `${SERVER_URL}/admin/release-user`,
  ADMIN_UPDATE_ONBOARDING: `${SERVER_URL}/admin/update-onboarding`,
  ADMIN_SET_LIVESTREAM_DEADLINE: `${SERVER_URL}/admin/set-livestream-deadline`,
  ADMIN_SEARCH_USERS_FOR_POOL: `${SERVER_URL}/admin/search-users-for-pool`,
  ADMIN_SET_AVAILABLE: `${SERVER_URL}/admin/set-available`,

  // Admin Livestream Monitoring
  LIVESTREAM_MONITOR_CHECK: `${SERVER_URL}/livestream-monitor/check`,
  LIVESTREAM_MONITOR_CLEANUP: `${SERVER_URL}/livestream-monitor/cleanup`,
  LIVESTREAM_MONITOR_STATUS: `${SERVER_URL}/livestream-monitor/status`,
  LIVESTREAM_MONITOR_ALERTS: `${SERVER_URL}/livestream-monitor/alerts`,

  // Admin Test Chat
  ADMIN_TEST_CHAT_SEND: `${SERVER_URL}/admin/test-chat/send`,
  ADMIN_TEST_CHAT_LIVESTREAMS: `${SERVER_URL}/admin/test-chat/livestreams`,
  ADMIN_TEST_CHAT_STREAM_USERS: `${SERVER_URL}/admin/test-chat/stream-users`,
  ADMIN_TEST_USER_POOL_USERS: `${SERVER_URL}/admin/test-user-pool/users`,

  // Admin Balance Management
  ADMIN_GET_ALL_BALANCES: `${SERVER_URL}/admin/balances/v2`,
  ADMIN_GET_USER_BALANCE_DETAILS: `${SERVER_URL}/admin/balance`,
  ADMIN_MODIFY_USER_BALANCE: `${SERVER_URL}/admin/balance`,
  ADMIN_RELEASE_LOCK: `${SERVER_URL}/admin/balance`,
  ADMIN_RECONCILE_BALANCE: `${SERVER_URL}/admin/balance`,
  ADMIN_TRANSFER_TOKENS: `${SERVER_URL}/admin/transfer/tokens`,
  ADMIN_TRANSFER_EXTERNAL: `${SERVER_URL}/admin/transfer/external`,
  ADMIN_TRANSFER_HISTORY: `${SERVER_URL}/admin/transfer/history`,
  ADMIN_AVAILABLE_WALLETS: `${SERVER_URL}/admin/wallets/available`,
  ADMIN_GET_WALLET_HISTORY: `${SERVER_URL}/admin/wallet-history`,
  ADMIN_GET_WALLET_CHANGES: `${SERVER_URL}/admin/wallet-changes`,
  ADMIN_CLEAR_LIVESTREAM_TIMESTAMPS: `${SERVER_URL}/admin/clear-livestream-timestamps`,

  // Admin Dashboard
  ADMIN_GET_ROYALTIES: `${SERVER_URL}/admin/royalties`,
  ADMIN_GET_LIVESTREAM_HISTORY: `${SERVER_URL}/admin/livestream-history`,
  ADMIN_ADOPTION_METRICS: `${SERVER_URL}/admin/adoption-metrics`,
  ADMIN_REFERRALS: `${SERVER_URL}/admin/referrals`,
  GAMIFICATION_PERFORMANCE_SUMMARY: `${SERVER_URL}/gamification/health/performance/summary`,
  GAMIFICATION_DASHBOARD: `${SERVER_URL}/gamification/health/dashboard`,
  GAMIFICATION_METRICS_HISTORICAL: `${SERVER_URL}/gamification/health/metrics/historical`,

  //Auth
  googleLogin: `${SERVER_URL}/auth/google/web`,
  appleLogin: `${SERVER_URL}/auth/apple/web`,
  testUserLogin: `${SERVER_URL}/auth/login/test`,
  addUsersToStream: `${SERVER_URL}/auth/addUsersToStream`,
  INVITE_ROYALTIES: `${SERVER_URL}/auth/invite/royalty`,
  INVITE_COLLABORATOR: `${SERVER_URL}/auth/invite/collaborator`,
  ADMIN_ADD_USERS_TO_STREAM: `${SERVER_URL}/auth/addUsersToStream`,
  REGISTER_DEVICE_TOKEN: `${SERVER_URL}/notification/register-device`,

  // USER
  FUNDLINK: `${SERVER_URL}/payment/moonpay/create`,
  PAYPALLINK: `${SERVER_URL}/payment/paypal/order`,
  PAYPALLCAPTURE: `${SERVER_URL}/payment/paypal/capture?`,
  PAYPALLCANCEL: `${SERVER_URL}/payment/paypal/cancel/order`,

  SEARCH_USER: `${SERVER_URL}/user/search?keyword=`,
  FEATURE_USER: `${SERVER_URL}/user/list/featured?`,
  FEATURE_ARTIST: `${SERVER_URL}/user/featured/list?`,
  ADD_TOP_MUSIC: `${SERVER_URL}/user/top/music`,
  FLAG_USER: `${SERVER_URL}/user/flag/asset`,
  ATTRIBUTES: `${SERVER_URL}/user/attributes`,
  SET_USER_TIMEZONE: `${SERVER_URL}/user/settings/timezone`,
  //Music
  UPLOAD_LIMITS: `${SERVER_URL}/music/upload-limits`,
  UPLOAD_MUSIC: `${SERVER_URL}/music/upload`,
  MY_MUSIC: `${SERVER_URL}/music/all?`,
  FEATURE_MUSIC: `${SERVER_URL}/music/featured/list?`,
  SEARCH_MUSIC: `${SERVER_URL}/music/search?keyword=`,
  MUSIC_DETAIL: `${SERVER_URL}/music/details?_id=`,
  ALL_ARTIST_MUSIC: `${SERVER_URL}/music/artist/list`,
  INDIVIDUAL_SONG_TIPPER: `${SERVER_URL}/music/toptipper?`,
  TOP_STREAMERS_FOR_SONG: `${SERVER_URL}/music/topstreamers?musicId=`,
  PLAYLISTS_BY_SONG: `${SERVER_URL}/playlist/bysong?musicId=`,
  VIDEOS_BY_SONG: `${SERVER_URL}/video/bysong?musicId=`,
  //Albums
  MY_ALBUM: `${SERVER_URL}/album/user?id=`,
  CREATE_ALBUM: `${SERVER_URL}/album/create`,
  DELETE_ALBUM: `${SERVER_URL}/album/delete?_id=`,
  EDIT_ALBUM: `${SERVER_URL}/album/edit?_id=`,
  ADD_SONGS_TO_ALBUM: `${SERVER_URL}/album/add/music`,
  ALBUM_DETAILS: `${SERVER_URL}/album/details?`,
  DELETE_SONG_FROM_ALBUM: `${SERVER_URL}/album/remove/music`,

  //Saves
  SAVES: `${SERVER_URL}/saves`,

  


  //Playlist
  PLAYLIST: `${SERVER_URL}/playlist/user/all`,
  MY_PLAYLIST: `${SERVER_URL}/playlist/user/all`,
  CREATE_PLAYLIST: `${SERVER_URL}/playlist/create`,
  DELETE_PLAYLIST: `${SERVER_URL}/playlist/delete?_id=`,
  FEATURE_PLAYLIST: `${SERVER_URL}/playlist/featured/list?`,
  SEARCH_PLAYLIST: `${SERVER_URL}/playlist/search?keyword=`,
  PLAYLIST_DETAIL: `${SERVER_URL}/playlist/details?`,
  EDIT_PLAYLIST: `${SERVER_URL}/playlist/edit`,
  ADD_SONG_TO_PLAYLIST: `${SERVER_URL}/playlist/add/music`,
  REMOVE_SONG_FROM_PLAYLIST: `${SERVER_URL}/playlist/remove/music`,
  SAVE_PLAYLIST: `${SERVER_URL}/playlist/save/playlist`,
  GET_PLAYLIST_MUSIC: `${SERVER_URL}/playlist/music/all?`,
  TOPTEN_MY_PLAYLIST: `${SERVER_URL}/playlist/created?`,
  TOPTEN_BUY_ME_PLAYLIST: `${SERVER_URL}/playlist/purchased?`,
  //Genre
  GENRE_LIST: `${SERVER_URL}/music/genre/list`,
  //NFT
  CREATE_PLAYLIST_NFT: `${SERVER_URL}/nft/create/playlist`,
  CREATE_PLAYLIST_NFT_V4: `${SERVER_URL}/nft/create/playlist/v4`,
  // CREATE_MUSIC_NFT: `${SERVER_URL}/nft/create/audio`,
  CREATE_MUSIC_NFT: `${SERVER_URL}/nft/create/audio/v2`,
  CREATE_MUSIC_NFT_V4: `${SERVER_URL}/nft/create/audio/v4`,
  CREATE_MUSIC_NFT_V5: `${SERVER_URL}/nft/create/audio/v6`,

  MUSIC_NFT: `${SERVER_URL}/nft/market/place?type=music`,
  PLAYLIST_NFT: `${SERVER_URL}/nft/market/place?type=playlist`,
  NFT_BY_ID: `${SERVER_URL}/nft/details?nftId=`,
  NFT_BY_ID_V2: `${SERVER_URL}/nft/details/v2?nftId=`,
  PLAYLIST_NFT_BY_ID: `${SERVER_URL}/nft/playlist/details?nftId=`,
  BID_NFT: `${SERVER_URL}/nft/auction/bid`,
  BID_NFT_V2: `${SERVER_URL}/nft/auction/bid/v2`,

  SELL_NFT: `${SERVER_URL}/nft/sale/create`,
  SELL_NFT_V2: `${SERVER_URL}/nft/sale/create/v2`,

  BUY_NFT: `${SERVER_URL}/nft/sale/buy`,
  BUY_NFT_V2: `${SERVER_URL}/nft/sale/buy/v2`,
  BUY_MUSIC_NFT: `${SERVER_URL}/nft/music/buy`,
  AUCTION_NFT: `${SERVER_URL}/nft/auction/create`,
  AUCTION_NFT_V2: `${SERVER_URL}/nft/auction/create/v2`,
  NFT_OFFERS: `${SERVER_URL}/offer/nft/sale?id=`,
  CANCEL_SELL: `${SERVER_URL}/nft/sale/cancel`,
  CANCEL_SELL_V2: `${SERVER_URL}/nft/sale/cancel/v2`,
  CANCEL_AUCTION_NFT: `${SERVER_URL}/nft/auction/cancel`,
  CANCEL_AUCTION_NFT_V2: `${SERVER_URL}/nft/auction/cancel/v2`,

  //User
  USER_DETAILS: `${SERVER_URL}/user/details?_id=`,
  USER_PROFILE: `${SERVER_URL}/user/profile`,
  UPDATE_USER: `${SERVER_URL}/user/profile/update`,
  PROFILE_UPDATE: `${SERVER_URL}/user/profile/change`,
  USER_NFT_MUSIC: `${SERVER_URL}/nft/list/v3?`,
  USER_NFT_PLAYLIST: `${SERVER_URL}/nft/playlist/user?`,
  // Gallery
  GALLERY_PRESIGN: `${SERVER_URL}/gallery/presign`,
  GALLERY_CREATE: `${SERVER_URL}/gallery`,
  GALLERY_BY_USER: `${SERVER_URL}/gallery/user/`,
  GALLERY_ITEM: `${SERVER_URL}/gallery/`,
  GALLERY_BASE: `${SERVER_URL}/gallery`,
  //Subscription
  UPDATE_SUBSCRIPTION: `${SERVER_URL}/subscription/artist/update`,
  GET_SUBSCRIPTIONS: `${SERVER_URL}/subscription/list?pageNo=1&pageSize=10&id=`,
  RENEWAL_SUBSCRIPTION_URL: `${SERVER_URL}/subscription/toggle/auto/renewal?autoRenewal=`,
  CREATE_SUBSCRIPTIONS: `${SERVER_URL}/subscription/create`,
  SUBSCRIBE_ARTIST: `${SERVER_URL}/subscription/artist`,
  UNSUBSCRIBE_ARTIST: `${SERVER_URL}/subscription/artist/cancel`,
  GIFT_ARTIST_SUBSCRIPTION: `${SERVER_URL}/subscription/artist/gift`,
  ASSET_PRIVACY: `${SERVER_URL}/subscription/assets/privacy`,
  UNLOCKED_ASSETS: `${SERVER_URL}/subscription/assets?`,
  PRIVATE_ASSETS: `${SERVER_URL}/subscription/user/assets?id=`,
  //FOLLOW
  FOLLOWERLIST: `${SERVER_URL}/follow/follower/list?user=`,
  FOLLOWINGLIST: `${SERVER_URL}/follow/following/list?user=`,
  UNFOLLOW: `${SERVER_URL}/follow/unfollow`,
  FOLLOW: `${SERVER_URL}/follow/user`,
  FOLLOW_STATUS: `${SERVER_URL}/follow/status?users=`,
  //NOtification
  NOTIFICATIONS: `${SERVER_URL}/notification/list`,
  MARK_SEEN: `${SERVER_URL}/notification/mark/read?`,
  MARK_ALL_SEEN: `${SERVER_URL}/notification/mark/readall?`,
  UNREAD: `${SERVER_URL}/notification/unread?pageNo=1&pageSize=13`,

  //WALLET
  BALANCE: `${SERVER_URL}/user/balance/v5`,
  TRANSACTIONS: `${SERVER_URL}/user/transactions?`,
  TOKEN_LIMIT_REQUEST: `${SERVER_URL}/request/increase/token/limit`,

  //Offboard
  OFFBOARD_CASHOUT: `${SERVER_URL}/offboard/cashout`,
  OFFBOARD_CASHOUT_LIST: `${SERVER_URL}/offboard/cashout/list`,
  OFFBOARD_CASHOUT_SEND: `${SERVER_URL}/offboard/cashout/send`,

  //Payment
  TIP_ARTIST: `${SERVER_URL}/payment/tip`,
  TIP_PLAYLIST: `${SERVER_URL}/payment/tip/playlist`,
  //gamification
  CURATOR_DATA: `${SERVER_URL}/gamification/data?userid=`,
  CREATOR_DATA: `${SERVER_URL}/gamification/creator/data?userid=`,
  GLOBAL_LEADERBOARD: `${SERVER_URL}/gamification/leaderboard`,
  
  //gamification v2 - OPTIMIZED (5-10x faster)
  GAMIFICATION_COMPLETE: `${SERVER_URL}/gamification/v2/complete`,
  GAMIFICATION_CURATOR_V2: `${SERVER_URL}/gamification/v2/curator`,
  GAMIFICATION_CREATOR_V2: `${SERVER_URL}/gamification/v2/creator`,
  GLOBAL_LEADERBOARD_V2: `${SERVER_URL}/gamification/v2/leaderboard`,
  LEADERBOARD_POSITION: `${SERVER_URL}/gamification/v2/leaderboard/position`,
  TOPTEN_LISTEN_PLAYLIST: `${SERVER_URL}/gamification/playlistsat/topten/listens/playlists`,
  TOPTEN_TIP_PLAYLIST: `${SERVER_URL}/gamification/playliststat/topten/tip/playlists?`,
  TOPTEN_SAVED_PLAYLIST: `${SERVER_URL}/gamification/playliststat/saved/playlists`,
  PLAYLIST_STATICS: `${SERVER_URL}/gamification/playliststat?`,
  
  //Analytics

    // Feed
  FEED_MUSIC: `${SERVER_URL}/feed/music`,
  FEED_VIDEO: `${SERVER_URL}/feed/video`,
  FEED_ALL: `${SERVER_URL}/feed/all`,

  //CURATOR
  LIFETIME_TIPS: `${SERVER_URL}/gamification/curator/tips?range=`,
  LIFETIME_LISTEN: `${SERVER_URL}/gamification/curator/listen?range=`,
  LIFETIME_SUBSCRIPTION: `${SERVER_URL}/gamification/curator/subscriptions?range=`,
  LIFETIME_OWNED: `${SERVER_URL}/gamification/curator/owned/nfts/?range=`,
  LIFETIME_PURCHASE: `${SERVER_URL}/gamification/curator/purchased/nfts?range=`,
  LIFETIME_PLAYLISTS: `${SERVER_URL}/gamification/curator/created/playlists?range=`,
  LIFETIME_STREAMS: `${SERVER_URL}/gamification/curator/streamed/playlists?range=`,
  CURATOR_TAB_DATA: `${SERVER_URL}/gamification/curator/counts?range=`,

  //Creator
  CREATOR_STREAMS: `${SERVER_URL}/gamification/creator/playlists/streams?range=`,
  SONG_RELEASED: `${SERVER_URL}/gamification/creator/released/songs?range=`,
  NFT_SOLD: `${SERVER_URL}/gamification/creator/nft/sold?range=`,
  PLAYLIST_ADD: `${SERVER_URL}/gamification/creator/playlist/adds?range=`,
  CREATOR_TAB_DATA: `${SERVER_URL}/gamification/creator/counts?range=`,
  //HomeScreen

  //Music
  MUSIC_ALL: `${SERVER_URL}/homescreen/music`,
  MUSIC_MOST_LISTEN: `${SERVER_URL}/homescreen/music/mostlisten`,
  MUSIC_MOST_STREAM_TODAY: `${SERVER_URL}/homescreen/music/moststreamed/today`,
  MUSIC_MOST_STREAM_WEEK: `${SERVER_URL}/homescreen/music/moststreamed/thisweek`,
  MUSIC_NEW_RELEASE: `${SERVER_URL}/homescreen/music/newrelease`,
  MUSIC_MOST_TIPPED: `${SERVER_URL}/homescreen/music/mosttipped`,
  MUSIC_TRENDING_TICKER: `${SERVER_URL}/homescreen/v3/music/trending-ticker`,
  //Nft
  NFT_ALL: `${SERVER_URL}/homescreen/nft`,
  MOSTEXPENSIVE: `${SERVER_URL}/homescreen/nft/mostexpensive`,
  PLAYLISTMOSTEXPENSIVE: `${SERVER_URL}/homescreen/nft/playlist/mostexpensive`,
  LEASTEXPENSIVE: `${SERVER_URL}/homescreen/nft/leastexpensive`,
  PLAYLISTLEASTEXPENSIVE: `${SERVER_URL}/homescreen/nft/playlist/leastexpensive`,
  OWNERPERCENTAGE: `${SERVER_URL}/homescreen/nft/owner/percentage`,
  ENDINGSOONAUCTION: `${SERVER_URL}/homescreen/nft/endingsoon`,
  GET_NFT_FRACTIONS: `${SERVER_URL}/fractions/available?musicId=`,
  GIFT_NFT_FRACTIONS: `${SERVER_URL}/fractions/gift`,
  ALL_NFT: `${SERVER_URL}/nft?`,
  GIFT_PLAYLIST_NFT: `${SERVER_URL}/fractions/gift/playlist`,
  NFT_RANK: `${SERVER_URL}/nft/owners?musicId=`,
  ACTIVE_BID: `${SERVER_URL}/nft/active?musicId=`,
  //PLAYLIST
  PLAYLIST_ALL: `${SERVER_URL}/homescreen/playlist`,
  PLAYLIST_MOST_TIPPED: `${SERVER_URL}/homescreen/playlist/mosttipped?`,
  PLAYLIST_STREAMED: `${SERVER_URL}/homescreen/playlist/moststream`,
  PLAYLIST_NEW_RELEASE: `${SERVER_URL}/homescreen/playlist/new/release`,
  PLAYLIST_STREAMED_LASTWEEK: `${SERVER_URL}/homescreen/playlist/lastweek/most/streamed`,
  PLAYLIST_MOST_STREAMED: `${SERVER_URL}/homescreen/playlist/today/most/streamed`,
  PLAYLIST_ALL_: `${SERVER_URL}/playlist/unread?createdBy=`,
  SORT_PLAYLIST_MUSIC: `${SERVER_URL}/playlist/update/order`,
  //Stream
  STREAM_ADD: `${SERVER_URL}/streaming/add`,
  STREAM_START: `${SERVER_URL}/streaming/start`,
  STREAM_PAUSE: `${SERVER_URL}/streaming/pause`,
  STREAM_HEARTBEAT: `${SERVER_URL}/streaming/heartbeat`,
  STREAM_STOP: `${SERVER_URL}/streaming/stop`,

  //Public
  CHARGES: `${SERVER_URL}/public/charges`,
  //Banner
  BANNER: `${SERVER_URL}/user/media/banners`,
  ADMIN_BANNERS: `${SERVER_URL}/admin/banners`,
  //Chat
  GET_MESSAGES: `${SERVER_URL}/message/getall`,
  GET_ONLINE_USERS: `${SERVER_URL}/message/onlineusers`,
  GET_PLAYLIST_TOP_FIVE: `${SERVER_URL}/message/playlisttopfive?`,
  PLAYLIST_TOP_MOST_TIPPED: `${SERVER_URL}/homescreen/playlist/mosttipped?`,
  PLAYLIST_TOP_MOST_STREAMED: `${SERVER_URL}/homescreen/playlist/moststream?`,
  GET_TOP_CHATS: `${SERVER_URL}/message/toptenusers?userId=`,
  GET_PRIVATE_MESSAGE: `${SERVER_URL}/message/private?`,
  READ_MESSAGE: `${SERVER_URL}/message/mark/readall?`,
  GROUP_CHAT: `${SERVER_URL}/message/chatdata?userId=`,
  GROUP_CHAT_V2: `${SERVER_URL}/message/chatdata/v2?userId=`,
  GET_ROOM_ID: `${SERVER_URL}/message/check/room?`,
  GET_PLAYLIST_MESSAGE: `${SERVER_URL}/message/playlist?`,
  BLOCK_USER_CHAT: `${SERVER_URL}/message/block`,
  CLEAR_PLAYLIST_CHAT: `${SERVER_URL}/message/playlist/clear`,
  CLEAR_DIRECT_CHAT: `${SERVER_URL}/message/direct/clear`,
  BLOCKER_USER: `${SERVER_URL}/message/block/check?roomId=`,
  DM_SETTINGS: `${SERVER_URL}/message/dm-settings`,
  DM_ACCESS: `${SERVER_URL}/message/dm-access?userId=`,
  //Auction house
  BID_LIST: `${SERVER_URL}/offer/bid?nftId=`,
  AUCTION_LIST: `${SERVER_URL}/offer/nft?nftId=`,
  BID_AND_AUCTIONS: `${SERVER_URL}/offer/list`,
  OFFERS: `${SERVER_URL}/offer/music/offer?id=`,
  ACTIVITY: `${SERVER_URL}/offer/music/activity?id=`,
  OFFERS_PLAYLIST: `${SERVER_URL}/offer/playlist/offer?id=`,
  ACTIVITY_PLAYLIST: `${SERVER_URL}/offer/playlist/activity?id=`,

  //Offers
  OFFERS_SALE: `${SERVER_URL}/offer/nft/sale?assetId=`,
  OFFERS_AUCTION: `${SERVER_URL}/offer/nft/auction?assetId=`,

  //Streaming
  TOP_TIPPERS: `${SERVER_URL}/livestream/mosttipped?channelName=`,
  LIVESTREAM: `${SERVER_URL}/livestream/live`,
  LAYOUT: `${SERVER_URL}/livestream/layout?`,
  LIVEEND: `${SERVER_URL}/livestream/end/host`,
  LIVESTART: `${SERVER_URL}/livestream/start/host`,
  LIVEJOIN: `${SERVER_URL}/livestream/join`,
  LIVE_TOKEN_RENEW: `${SERVER_URL}/livestream/token/renew`,
  LIVEEXIT: `${SERVER_URL}/livestream/exit`,
  //MATIC

  CREATE_MATIC: `${SERVER_URL}/user/wallet/create/v3`,
  GOAL: `${SERVER_URL}/playlist/goal?playlistId=`,

  //VIDEO
  DELETE_VIDEO: `${SERVER_URL}/studio/:studioId/video/:videoId`,
  UPDATEVIDEO: `${SERVER_URL}/studio/:studioId/video/:videoId`,
  VIDEO_BY_UPLOADER: `${SERVER_URL}/studio/videos/by-uploader/`,
  

  VIDEO_USER: `${SERVER_URL}/studio/:studioId/videos`,
  UPVID: `${SERVER_URL}/studio/:studioId/video`,
  VIDEO: `${SERVER_URL}/user/videos`,
  VIDEO_SEARCH: `${SERVER_URL}/studio/video/search`,
  FEATURE_VIDEO: `${SERVER_URL}/studio/video/featured/list`,
  CREATE_CLIP: `${SERVER_URL}/clip/create`,
  UPLOAD_CLIP: `${SERVER_URL}/clip/upload`,
  VIEW_CLIP: `${SERVER_URL}/clip`,
  STREAM_CLIPS: `${SERVER_URL}/clip/stream`,
  USER_CLIPS: `${SERVER_URL}/clip/user`,
  DELETE_CLIP: `${SERVER_URL}/clip`,
  DOWNLOAD_RECORDING: `${SERVER_URL}/livestream/download?key=`,
  RECORDINGS: `${SERVER_URL}/livestream/recording?`,
  UPLOAD_RECORDING: `${SERVER_URL}/livestream/recording/upload`,
  DELETE_RECORDING: `${SERVER_URL}/livestream/recording/:recordingId`,
  UPDATE_RECORDING: `${SERVER_URL}/livestream/recording/:recordingId`,
  LANGUAGE: `${SERVER_URL}/init?`,
  UPDATE_GIFT_STATUS: `${SERVER_URL}/nft/opened`,
  ADD_COUNT: `${SERVER_URL}/public/config?`,
  ADD: `${SERVER_URL}/ad/ads?`,
  AD_IMPRESSION: `${SERVER_URL}/ad/impression`,
  AD_NEXT: `${SERVER_URL}/ad/next`,
  AD_CLICK: `${SERVER_URL}/ad/click`,
  ADMIN_ADS: `${SERVER_URL}/ad/all`,
  ADMIN_AD_UPLOAD: `${SERVER_URL}/ad/upload`,
  ADMIN_AD_UPDATE: `${SERVER_URL}/ad/update`,
  ADMIN_AD_ORDER: `${SERVER_URL}/ad/order`,
  ADMIN_SPONSORS: `${SERVER_URL}/ad/sponsors`,
  ADMIN_SPONSOR: `${SERVER_URL}/ad/sponsor`,
  ADMIN_SPONSOR_UPDATE: `${SERVER_URL}/ad/sponsor/update`,
  ADMIN_SPONSORSHIP_PACKAGES: `${SERVER_URL}/ad/packages`,
  ADMIN_SPONSORSHIP_PACKAGE: `${SERVER_URL}/ad/package`,
  ADMIN_SPONSORSHIP_PACKAGE_UPDATE: `${SERVER_URL}/ad/package/update`,
  ADMIN_AD_CAMPAIGNS: `${SERVER_URL}/ad/campaigns`,
  ADMIN_AD_CAMPAIGN: `${SERVER_URL}/ad/campaign`,
  ADMIN_AD_CAMPAIGN_UPDATE: `${SERVER_URL}/ad/campaign/update`,
  ADMIN_AD_CAMPAIGN_REPORT: `${SERVER_URL}/ad/campaign/report`,
  ADMIN_SPONSORSHIP_DEAL: `${SERVER_URL}/ad/deal`,
  ADMIN_PAYOUT_COVERAGE: `${SERVER_URL}/ad/payout-coverage`,

  //ARtist profile
  TRENDING: `${SERVER_URL}/user/trending?artistId=`,
  TOP_LIST: `${SERVER_URL}/artist/content?`,
  MUSIC_LIST: `${SERVER_URL}/artist/music?`,

  // Artist Search
  SEARCH_ARTIST: `${SERVER_URL}/artist/search?keyword=`,

  // Elastic Search
  SEARCH: `${SERVER_URL}/search?keyword=`,

  // Schedule
  SCHEDULE_LIVESTREAM: `${SERVER_URL}/schedule/livestream`,
  SCHEDULE_LIVESTREAM_CANCEL: `${SERVER_URL}/schedule/livestream/cancel`,
  SCHEDULE_LIVESTREAMS: `${SERVER_URL}/schedule/livestreams?`,
  SCHEDULE_LIVESTREAMS_DATE: `${SERVER_URL}/schedule/livestreams/date?`,
  SCHEDULE_LIVESTREAMS_USER: `${SERVER_URL}/schedule/livestreams/user?`,

  // Dynamic Links
  CREATE_DYNAMIC_LINK: `${SERVER_URL}/dynamiclink/create`,

CREATE_CALENDAR_EVENT: `${SERVER_URL}/calendar/create`,
  FETCH_CALENDAR_EVENTS: `${SERVER_URL}/calendar/events`,
  UPDATE_CALENDAR_EVENT: `${SERVER_URL}/calendar/update`,
  DELETE_CALENDAR_EVENT: `${SERVER_URL}/calendar/delete/:id`,
  GET_TASKS: `${SERVER_URL}/calendar/tasks`,

  // Stream Purchase
  STREAM_PURCHASE: `${SERVER_URL}/stream-purchase/purchase`,
  STREAM_PRICING: `${SERVER_URL}/stream-purchase/pricing`,
  STREAM_PURCHASE_HISTORY: `${SERVER_URL}/stream-purchase/history`,

  // Song Requests
  SONG_REQUEST_SUBMIT: `${SERVER_URL}/song-requests/submit`,
  SONG_REQUEST_LIST: `${SERVER_URL}/song-requests/list`,
  SONG_REQUEST_MINE: `${SERVER_URL}/song-requests/mine`,
  SONG_REQUEST_HOST_PENDING: `${SERVER_URL}/song-requests/host-pending`,
  SONG_REQUEST_ACCEPT: `${SERVER_URL}/song-requests/accept`,
  SONG_REQUEST_REJECT: `${SERVER_URL}/song-requests/reject`,
  SONG_REQUEST_CLEAR: `${SERVER_URL}/song-requests/clear`,
  SONG_REQUEST_ACCEPTED_LIST: `${SERVER_URL}/song-requests/accepted`,
  SONG_REQUEST_MARK_PLAYED: `${SERVER_URL}/song-requests/played`,
  SONG_REQUEST_CONFIG: `${SERVER_URL}/song-requests/config`,
  SONG_REQUEST_QUEUE: `${SERVER_URL}/song-requests/queue`,
  SONG_REQUEST_EARNINGS: `${SERVER_URL}/song-requests/earnings`,
  SONG_REQUEST_JUKEBOX_DAY: `${SERVER_URL}/song-requests/jukebox`,
  SONG_REQUEST_HOST_DAYS: `${SERVER_URL}/song-requests/host/slots`,
  SONG_REQUEST_HOST_DAY: `${SERVER_URL}/song-requests/host/slot`,

  // Stream Keys (OBS Streaming)
  STREAM_KEYS: `${SERVER_URL}/stream-keys`,
  STREAM_KEYS_STATUS: `${SERVER_URL}/stream-keys/status`,
  LIVESTREAM_MODERATORS: `${SERVER_URL}/livestream/moderators`,
  LIVESTREAM_FORCE_DISCONNECT: `${SERVER_URL}/livestream/force-disconnect-audience`,
  STREAM_KEYS_START_LIVESTREAM: `${SERVER_URL}/stream-keys/start-livestream`,
  STREAM_KEYS_END_LIVESTREAM: `${SERVER_URL}/stream-keys/end-livestream`,

  // OBS Plugin API Keys
  OBS_API_KEY: `${SERVER_URL}/obs-plugin/api-key`,
  OBS_API_KEY_GENERATE: `${SERVER_URL}/obs-plugin/api-key/generate`,

  // Prospecting
  PROSPECT_LEADS: `${SERVER_URL}/prospect/api/leads`,
  PROSPECT_STATS: `${SERVER_URL}/prospect/api/stats`,
  PROSPECT_ACTIONS: `${SERVER_URL}/prospect/api/actions`,
  PROSPECT_FOLLOWUPS: `${SERVER_URL}/prospect/api/followups`,
  PROSPECT_INVESTORS: `${SERVER_URL}/prospect/api/investors`,
  PROSPECT_EMAILS: `${SERVER_URL}/prospect/api/emails`,
  PROSPECT_EMAILS_EXPORT: `${SERVER_URL}/prospect/api/emails/export`,
  PROSPECT_ACTION: `${SERVER_URL}/prospect/api/action`,
  PROSPECT_STATUS: `${SERVER_URL}/prospect/api/status`,
  PROSPECT_ARCHIVE: `${SERVER_URL}/prospect/api/archive`,
  PROSPECT_BULK_ACTION: `${SERVER_URL}/prospect/api/bulk-action`,

  // Share links
  CREATE_SHARE_LINK: `${SERVER_URL}/share/create-link`,

  // Ticketing
  TICKETING_EVENTS: `${SERVER_URL}/ticketing/events`,
  TICKETING_EVENT: `${SERVER_URL}/ticketing/event`,
  TICKETING_MY_EVENTS: `${SERVER_URL}/ticketing/events/mine`,
  TICKETING_PURCHASE: `${SERVER_URL}/ticketing/ticket/purchase`,
  TICKETING_MY_TICKETS: `${SERVER_URL}/ticketing/tickets/mine`,
  TICKETING_ADMIN_EVENTS: `${SERVER_URL}/ticketing/admin/events`,
  TICKETING_ADMIN_EVENT_TICKETS: `${SERVER_URL}/ticketing/admin/event`,
  TICKETING_TICKET: `${SERVER_URL}/ticketing/ticket`,
  TICKETING_ADMIN_SCAN_LOGS: `${SERVER_URL}/ticketing/admin/event`,
  TICKETING_CANCEL_EVENT: `${SERVER_URL}/ticketing/event`,

  // Screening Room
  SCREENING_DASHBOARD: `${SERVER_URL}/screening-room/dashboard`,
  SCREENING_ASSETS: `${SERVER_URL}/screening-room/assets`,
  SCREENING_LINKS: `${SERVER_URL}/screening-room/links`,

  // Gamification v2 — engagement (docs/GAMIFICATION_V2.md "HTTP surface")
  ENGAGEMENT_ME: `${SERVER_URL}/engagement/me`,
  ENGAGEMENT_ME_MISSIONS: `${SERVER_URL}/engagement/me/missions`,
  ENGAGEMENT_ME_HISTORY: `${SERVER_URL}/engagement/me/history`,
  ENGAGEMENT_ME_TIMELINE: `${SERVER_URL}/engagement/me/timeline`,
  ENGAGEMENT_ME_SHARE_REACH: `${SERVER_URL}/engagement/me/share-reach`,
  ENGAGEMENT_PLAYLIST_ACTIVITY: `${SERVER_URL}/engagement/playlist`,
  ENGAGEMENT_ME_REWARDS: `${SERVER_URL}/engagement/me/rewards`,
  ENGAGEMENT_ME_UNLOCKS: `${SERVER_URL}/engagement/me/unlocks`,
  ENGAGEMENT_EVENT: `${SERVER_URL}/engagement/event`,
  ENGAGEMENT_ARTIST: `${SERVER_URL}/engagement/artist`,
  ENGAGEMENT_ARTIST_REWARD: `${SERVER_URL}/engagement/artist/reward`,

  // Gamification v2 — artist insights
  INSIGHTS_ME_OVERVIEW: `${SERVER_URL}/insights/me/overview`,
  INSIGHTS_ME_STREAMS: `${SERVER_URL}/insights/me/streams`,
  INSIGHTS_ME_SONGS: `${SERVER_URL}/insights/me/songs`,
  INSIGHTS_ME_AUDIENCE: `${SERVER_URL}/insights/me/audience`,
  INSIGHTS_ME_MOMENTUM: `${SERVER_URL}/insights/me/momentum`,
  INSIGHTS_ME_MILESTONES: `${SERVER_URL}/insights/me/milestones`,
  INSIGHTS_ME_UNLOCKS: `${SERVER_URL}/insights/me/unlocks`,

  // Gamification v2 — leaderboards
  LEADERBOARDS_ARTISTS: `${SERVER_URL}/leaderboards/artists`,
  LEADERBOARDS_SONGS: `${SERVER_URL}/leaderboards/songs`,
  LEADERBOARDS_FANS: `${SERVER_URL}/leaderboards/fans`,
  LEADERBOARDS_ME_RANK: `${SERVER_URL}/leaderboards/me/rank`,

  // Gamification v2 — social proof + notification preferences
  SOCIAL_PROOF_ASSET: `${SERVER_URL}/social-proof/asset`,
  NOTIFICATION_PREFERENCES: `${SERVER_URL}/notification/preferences`,
};
